import { render, staticRenderFns } from "./ActivityExtension.vue?vue&type=template&id=cd21906e&scoped=true&"
import script from "./ActivityExtension.vue?vue&type=script&lang=js&"
export * from "./ActivityExtension.vue?vue&type=script&lang=js&"
import style0 from "./ActivityExtension.vue?vue&type=style&index=0&id=cd21906e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd21906e",
  null
  
)

export default component.exports